import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Grid, Row, Col } from "@vds/grids";
import { Badge } from "@vds/badges";
import { TextLink } from "@vds/buttons";
import { MarginSpacerM, MarginSpacerXS, MarginSpacerL, MarginSpacerS } from "../styleTag";
import GWJointOfferModal from "./GWJointOfferModal";
import { setGWJointOfferSelected, setBundleOfferSelected } from "pages/Mobility/ducks/MobilitySlice";
import { useDispatch } from "react-redux";
import "./GWjointOfferCard.css"
import { isMobile } from "react-device-detect";
export const getImageUrl = (url) => {
  if (!(typeof url === "string" && url?.length)) {
    return "";
  } else if (url.charAt(0) === "/") {
    return `${window?.mbtGlobal?.assetsBaseUrl}${url}`;
  } else {
    return url;
  }
};
const GWJointOfferCard = ({ aem, aemContent, aemContentModal, promoType, ...props }) => {
  const [additionalURL, handleAdditionalURL] = useState("");
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();


  const getImageHeight = () => {
    if ("connectedLaptops" === promoType) {
      return "98%";
    }
    return null;
  };

  const handleBundleClick = (e) => {
    e.preventDefault();
    dispatch(setGWJointOfferSelected(true));
    dispatch(setBundleOfferSelected(true));
    let URL = aemContent?.url;
    if (String(props.type).includes("connectedLaptops") && window.location.pathname.includes("/mbt/prospect")) {
      URL = aemContent?.lowerEnvUrl;
    }
    if (aemContent?.externalUrl) {
      window.open(URL, "_blank");
    } else {
      navigate(`/${URL}`);
    }

  }
  useEffect(() => {
    if (String(props.type).includes("non-smartPhone")) {
      const addURL = String(props.category)?.toLowerCase().split(" ");
      const resultURL =
        addURL.length > 1 ? addURL[0] + "-" + addURL[1] : addURL[0];
      handleAdditionalURL(resultURL + "/byod");
    }
  }, [props.category]);

  return (
    <>
      <DeviceContainer className="device-card-gwoffer">
        <a
          onClick={(e) => handleBundleClick(e)}
        >
          {/* <ProductBoxWrap
          imgHeight={getImageHeight()}
          url={getImageUrl(aemContent?.ss7ImgUrl)}
        >
        </ProductBoxWrap> */}
          {/* { <ImageContainer>
            <picture className="image-container">
              <source
                type="image/webp"
                srcset={getImageUrl(aemContent?.ss7ImgUrl, 130, 130, true)}
              />
              <DeviceImgContainer>
                <DevicePicture
                  url={getImageUrl(aemContent?.ss7ImgUrl, 130, 130)}
                ></DevicePicture>
              </DeviceImgContainer>
            </picture>
          </ImageContainer>} */}
          <DeviceDetailsContainer className="device-container">
            <Grid colGutter={false} rowGutter={0}>
              <Row>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                {isMobile ? <MarginSpacerS /> : <MarginSpacerM />}
                  <Badge fillColor="red">{aemContent?.badgeTxt}</Badge>
                  <MarginSpacerXS />
                </Col>
              </Row>
              <Row>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {!!aemContent?.headerText && (
                    <TextOnImage size="large" color="#FFFFFF" bold>
                      {aemContent?.headerText}
                    </TextOnImage>
                  )}
                  {isMobile ? <MarginSpacerS /> : <MarginSpacerM />}
                </Col>
              </Row>
              <Row>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {!!aemContent?.subHeaderText && (
                    <SubtextOnImage size="medium" color="#FFFFFF">
                      <div className="bundle-list"
                        dangerouslySetInnerHTML={{ __html: aemContent?.subHeaderText }}
                      ></div>

                    </SubtextOnImage>
                  )}
                </Col>
              </Row>
              <Row>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {isMobile ? <MarginSpacerS /> : <MarginSpacerL />}
                  {!!aemContent?.linkText && (
                    <LinkTextOnImage>
                      <LinkButton>{aemContent?.linkText}</LinkButton>
                    </LinkTextOnImage>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  {isMobile ? <MarginSpacerS /> : <MarginSpacerL />}
                  {!!aemContent?.subHeaderTextLink && (
                    <StyledTextLink className="text-link"
                      size="small"
                      color="#FFFFFF"
                      onClick={(e) => {
                        e.stopPropagation()
                        setShowModal(true)
                      }}

                    >{aemContent?.subHeaderTextLink}
                    </StyledTextLink>
                  )}
                  <MarginSpacerL/>
                </Col>
              </Row>
            </Grid>
          </DeviceDetailsContainer>
          {/* <TextOnImageWrapper>
            
          </TextOnImageWrapper> */}
        </a>
      </DeviceContainer>
      {showModal && <GWJointOfferModal setShowModal={setShowModal} showModal={showModal} aemContent={aemContentModal} />}
    </>
  );
};



const TextOnImage = styled(Title)`
  display: flex;
`;
const StyledTextLink = styled(TextLink)`
padding-right: 0px !important;
color:white !important;
.text-link : hover{
  color:white !important;
}
`;
const SubtextOnImage = styled(Body)`
  display: flex;
  letter-spacing: 0.5px;
`;

const LinkTextOnImage = styled.div`
  display: flex;
  align-items: center;
  display: flex;
  font-weight: 700;
  color: #FFFFFF;

  * {
    stroke: aliceblue !important;
  }
  & > a {
    padding-left: 0px;
  }
`;

const ImageContainer = styled.div`
height: 250px;
left: 0px;
top: 0px;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
position: relative;

@media (max-width: 767px){
  top: 0px;
  img{
    width:175px !important;
    height:175px !important;
    left: 13px;
    top: 60px; 
  }
  
}
`
const DeviceImgContainer = styled.div`
position: relative;
height: 250px;
width: 250px;
@media screen and (min-device-width: 320px) and (max-device-width: 767px){
width: 175px !important;
height: 175px !important;  
position: relative;
}
`
const LinkButton = styled(Button)`
    color: #fbf7f7 !important;
    border: #ffffff solid 1px !important;  
    height : 30px;
    font-size: small;
`;
const DevicePicture = styled.div`
position: relative;
background-image: ${({ url }) => `url("${url}")`};
height: 100%;
width: 100%;
background-size: auto 100%;
background-repeat: no-repeat;
background-position: left top;
`

const DeviceContainer = styled.div`
// margin-top: 10px;
cursor: pointer;
@media screen and (min-width:601px) and (max-width:954px){
  & {
    min-width:${((window.innerWidth / 3) - 30)}px !important;
    }
  }
`

const DeviceDetailsContainer = styled.div`
// margin-top:10px;
position:relative;
@media (max-width: 767px){
  position:relative;
  // top: 10px;
}
`

export default GWJointOfferCard;
